import { ISettingsDetails } from './interfaces/ISettingsDetails';
import { DEFAULT_GEOFENCE_RADIUS_MILES } from '../../common/LocationModal/geofenceConstants';

export const DEFAULT_GEOFENCE_RADIUS_MILES_SETTING =
    'DefaultGeofenceRadiusMiles';

export const INITIAL_SETTINGS_DETAILS: ISettingsDetails = {
    companyDetails: {
        brokerFeeType: 'Fixed',
        brokerFeeAmount: '',
        companyName: '',
        emailAddress: '',
        phoneNumber: '',
        faxNumber: '',
        dispatchSupportNumber: '',
        companyAddress: '',
        city: '',
        state: '',
        zipCode: '',
        companyLogo: '',
        baseSettingId: 0,
        settlementReportBatchNumber: '',
        defaultGeofenceRadius: DEFAULT_GEOFENCE_RADIUS_MILES,
    },
    communicationDetails: {
        isGreetingMessageIncluded: false,
        greetingMessage: '',
        isOrderNumberIncluded: false,
        isDateIncluded: false,
        isTimeFormat12Hr: false,
        isPinDropNameIncluded: false,
        isLocationInstructionIncluded: false,
        isEstimatedWeightIncluded: false,
        isEstimatedHeadCountIncluded: false,
        isCommodityIncluded: false,
        isDriverInstructionIncluded: false,
        isEndingMessageIncluded: false,
        endingMessage: '',
    },
    invoicingDetails: {
        isSendInvoices: false,
        invoiceRecipients: [],
        isQuickBooksConnected: false,
        isRoundInvoiceTotals: false,
        isQuickBooksOnlineConnected: false,
    },
    passwordExpiryMonths: 0,
    isBolRequiredInMobileApp: true,
    showHeadCountOrQuantity: '',
    // DEPRECATED: Legacy format for backward compatibility
    enabledTrailerSizes: [
        '_49k',
        '_52k',
        '_55_62k',
        '_68k',
        '_10500Gas',
        '_9800Diesel',
        '_9800Gas',
        '_9300DF',
    ],
    trailerSizes: [],
};

export const BROKER_FEE_TYPE = 'BrokerFeeType';
export const BROKER_FEE_AMOUNT = 'BrokerFeeAmount';
export const COMPANY_NAME = 'CompanyName';
export const COMPANY_ADDRESS = 'CompanyAddress';
export const CITY = 'City';
export const STATE = 'State';
export const ZIP_CODE = 'ZipCode';
export const PHONE_NUMBER = 'PhoneNumber';
export const DISPATCH_SUPPORT_NUMBER = 'DispatchSupportNumber';
export const FAX_NUMBER = 'FaxNumber';
export const EMAIL_ADDRESS = 'EmailAddress';
export const COMPANY_LOGO = 'CompanyLogo';
export const SETTLEMENT_REPORT_BATCH_NUMBER = 'SettlementReportBatchNumber';
export const IS_GREETING_MESSAGE_INCLUDED = 'IsIncludeGreetingMessage';
export const GREETING_MESSAGE = 'GreetingMessage';
export const IS_ORDER_NUMBER_INCLUDED = 'IsIncludeOrderNumber';
export const IS_DATE_INCLUDED = 'IsIncludeDate';
export const IS_TIME_FORMAT_12_HR = 'Is12HrTimeDisplayFormat';
export const IS_PIN_DROP_NAME_INCLUDED = 'IsIncludePinDropName';
export const IS_LOCATION_INSTRUCTION_INCLUDED = 'IsIncludeLocationInstructions';
export const IS_ESTIMATED_WEIGHT_INCLUDED = 'IsIncludeEstimatedWeight';
export const IS_ESTIMATED_HEAD_COUNT_INCLUDED = 'IsIncludeHeadCount';
export const IS_COMMODITY_INCLUDED = 'IsIncludeCommodity';
export const IS_DRIVER_INSTRUCTION_INCLUDED = 'IsIncludeDriverInstructions';
export const IS_ENDING_MESSAGE_INCLUDED = 'IsIncludeEndingMessage';
export const ENDING_MESSAGE = 'EndingMessage';
export const IS_SEND_INVOICE = 'IsSendInvoices';
export const INVOICE_RECIPIENTS = 'InvoiceRecipients';
export const IS_QUICKBOOKS_CONNECTED = 'IsQuickBooksConnected';
export const IS_QUICKBOOKS_ONLINE_CONNECTED = 'IsQuickBooksOnlineConnected';
export const INSTRUCTIONS_FILE = 'Instructions';
export const QWC_CONNECTION_FILE = 'QWC';
export const ROD_INVOICE_TEMPLATE = 'InvoiceTemplate';
export const INSTRUCTIONS_FILE_NAME = 'Connect_To_QuickBooks_Instructions.pdf';
export const QWC_CONNECTION_FILE_NAME = 'ROD_QB_Config_file.qwc';
export const ROD_INVOICE_TEMPLATE_NAME = 'Roll_On_Dispatch_Template.DES';
export const PASSWORD_EXPIRATION_MONTH = 'PasswordExpirationMonths';
export const IS_BOL_REQUIRED_IN_MOBILE_APP = 'IsBolRequiredInMobileApp';
export const IS_ROUND_INVOICE_TOTALS = 'IsRoundInvoiceTotals';
export const SHOW_HEADCOUNT_OR_QUANTITY = 'ShowHeadCountOrQuantity';
export const IS_TRAILER_49K_ENABLED = 'IsTrailer49kEnabled';
export const IS_TRAILER_52K_ENABLED = 'IsTrailer52kEnabled';
export const IS_TRAILER_55_62K_ENABLED = 'IsTrailer55_62kEnabled';
export const IS_TRAILER_68K_ENABLED = 'IsTrailer68kEnabled';
export const IS_TRAILER_10500_GAS_ENABLED = 'IsTrailer10500GasEnabled';
export const IS_TRAILER_9800_DIESEL_ENABLED = 'IsTrailer9800DieselEnabled';
export const IS_TRAILER_9800_GAS_ENABLED = 'IsTrailer9800GasEnabled';
export const IS_TRAILER_9300_DF_ENABLED = 'IsTrailer9300DFEnabled';

export const TRAILER_SIZE_49K = '_49k';
export const TRAILER_SIZE_52K = '_52k';
export const TRAILER_SIZE_55_62K = '_55_62k';
export const TRAILER_SIZE_68K = '_68k';
export const TRAILER_SIZE_10500_GAS = '_10500Gas';
export const TRAILER_SIZE_9800_DIESEL = '_9800Diesel';
export const TRAILER_SIZE_9800_GAS = '_9800Gas';
export const TRAILER_SIZE_9300_DF = '_9300DF';

export const VALID_TRAILER_CODES = [
    TRAILER_SIZE_49K,
    TRAILER_SIZE_52K,
    TRAILER_SIZE_55_62K,
    TRAILER_SIZE_68K,
    TRAILER_SIZE_10500_GAS,
    TRAILER_SIZE_9800_DIESEL,
    TRAILER_SIZE_9800_GAS,
    TRAILER_SIZE_9300_DF,
] as const;

export const LIVESTOCK_TRAILER_CODES = [
    TRAILER_SIZE_49K,
    TRAILER_SIZE_52K,
    TRAILER_SIZE_55_62K,
    TRAILER_SIZE_68K,
] as const;

export const FUEL_TRAILER_CODES = [
    TRAILER_SIZE_10500_GAS,
    TRAILER_SIZE_9800_DIESEL,
    TRAILER_SIZE_9800_GAS,
    TRAILER_SIZE_9300_DF,
] as const;

export const ENABLED_TRAILER_SIZES = 'EnabledTrailerSizes';

export const settingConstants = {
    tabs: {
        companyAndUserTab: 'Settings:companyAndUsers',
        brokerAndDriverTab: 'Settings:generalPreferences',
        communicationAndInvoice: 'Settings:communicationAndInvoices',
    },
};

export const UserStatus = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
];

export const UserRole = [
    { value: 'Admin', label: 'Admin' },
    { value: 'Dispatcher', label: 'Dispatcher' },
    { value: 'Finance', label: 'Finance' },
];
